import axiosClient from "@/api/axios";
import { retry } from "@/api/utils";
import { hashInput } from "@/utils/functions/security";
// import { sleep } from "@/utils/functions/general";

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Routes for Insight Detail Page
export const getInsightDetailsByAudience = retry(
  async ({
    orderId,
    itemId,
    audienceId,
    aController,
  }: {
    orderId: string;
    itemId: number;
    audienceId: string;
    aController: AbortController;
  }) => {
    try {
      const response = await axiosClient({
        method: "GET",
        url: `${VITE_API_BASE_URL}/orders/${orderId}/items/${itemId}/audiences/${audienceId}/data`,
        signal: aController.signal,
      });

      return response.data;
    } catch (error: any) {
      if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
        return { status: "aborted" };
      }
      throw error;
    }
  }
);
export const validateAudience = async ({
  audienceId,
  aController,
  jsonConfig,
}: {
  audienceId: string;
  aController: AbortController;
  jsonConfig: any;
}) => {
  try {
    if (!jsonConfig || !audienceId)
      throw new Error(
        "Invalid parameters: jsonConfig and audienceId are required"
      );

    const SHACODE = hashInput(jsonConfig);

    const headers: HeadersInit = {
      "Content-Type": "application/json",
      "X-Amz-Content-Sha256": SHACODE,
    };

    const response = await axiosClient({
      method: "POST",
      url: `${VITE_API_BASE_URL}/previews/insight/${audienceId}`,
      signal: aController.signal,
      headers,
      data: jsonConfig,
    });
    return response.data;
  } catch (error: any) {
    if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
      return { status: "aborted" };
    }
    throw error;
  }
};

// function getRandomInt(max) {
//   return Math.floor(Math.random() * max);
// }

// async function generateRandomAudienceResponse() {
// await sleep(1000);
//     const randomNumber = getRandomInt(3);
//     if (randomNumber === 0) {
//       return sample_response_good; // Simulate a good response
//     } else if (randomNumber === 1) {
//       return sample_response_limited_sample_size; // Simulate a limited sample size response
//     } else if (randomNumber === 2) {
//       return sample_response_no_data; // Simulate a no data response
//     }
// }

export const sample_response_good = {
  audience_definition: {
    demographics: [
      {
        level_id: 12268,
        level_name: "18+",
        variable_id: "F999",
        variable_name: "Age",
      },
    ],
    geography: [
      {
        level_name: "CAN",
        variable_name: "Country",
      },
    ],
  },
  hierarchy: [
    {
      id: "994",
      label: "VARIABLE",
    },
  ],
  id: "F1056",
  levels: [
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12420,
      name: "0-7 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12463,
      name: "8-12 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12502,
      name: "13-17 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12538,
      name: "18-24 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12577,
      name: "25 years old or older",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12617,
      name: "N/A \u2013 I don\u2019t have a favorite team",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12661,
      name: "N/A \u2013 Not a fan of this league",
    },
  ],
  limited_sample_size: false,
  name: "Age became a fan of NBA team(s)",
  report_id: 121,
  report_name:
    "on_demand_north_america Report - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
  sequence: 1,
  timeframe: ["OCT2022", "NOV2022", "DEC2022"],
};
export const sample_response_limited_sample_size = {
  audience_definition: {
    demographics: [
      {
        level_id: 12268,
        level_name: "18+",
        variable_id: "F999",
        variable_name: "Age",
      },
    ],
    geography: [
      {
        level_name: "CAN",
        variable_name: "Country",
      },
    ],
  },
  hierarchy: [
    {
      id: "994",
      label: "VARIABLE",
    },
  ],
  id: "F1056",
  levels: [
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12420,
      name: "0-7 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12463,
      name: "8-12 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12502,
      name: "13-17 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12538,
      name: "18-24 years old",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12577,
      name: "25 years old or older",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12617,
      name: "N/A \u2013 I don\u2019t have a favorite team",
    },
    {
      audiences: [
        {
          audience_sequence: 1,
          count: {
            audience_sample_size: "x",
            index: "x",
            market_size: "x",
            percentage: "x",
            weighted_response_count: "x",
          },
          id: 121,
          name: "on_demand_north_america Audience - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
          p_value: "x",
          stat_diff: "x",
        },
      ],
      id: 12661,
      name: "N/A \u2013 Not a fan of this league",
    },
  ],
  limited_sample_size: true,
  name: "Age became a fan of NBA team(s)",
  report_id: 121,
  report_name:
    "on_demand_north_america Report - 4ae36718-2e81-45b3-afd7-e1d6823c71fc",
  sequence: 1,
  timeframe: ["OCT2022", "NOV2022", "DEC2022"],
};

export const sample_response_no_data = {
  audience_definition: {
    demographics: [
      {
        level_id: 12177,
        level_name: "Male",
        variable_id: "F1005",
        variable_name: "Gender",
      },
      {
        level_id: 12379,
        level_name: "13-17",
        variable_id: "F999",
        variable_name: "Age",
      },
      {
        level_id: 12407,
        level_name: "Associate’s degree",
        variable_id: "F1024",
        variable_name: "Education",
      },
      {
        level_id: 12446,
        level_name: "Bachelor’s degree",
        variable_id: "F1024",
        variable_name: "Education",
      },
      {
        level_id: 12491,
        level_name: "Master’s degree",
        variable_id: "F1024",
        variable_name: "Education",
      },
      {
        level_id: 12907,
        level_name: "Green Bay Packers",
        variable_id: "F1004",
        variable_name: "Team Fandom - National Football League (NFL)",
      },
      {
        level_id: 13044,
        level_name: "Los Angeles Angels",
        variable_id: "F1013",
        variable_name: "Team Fandom - Major League Baseball (MLB)",
      },
    ],
    geography: [
      {
        level_name: "CAN",
        variable_name: "Country",
      },
    ],
  },
  details: "This variable has no data available for the selected filters.",
  error: true,
  message: "No Data Available",
  prompt: "Please select other filters to try again",
  variable_id: 1030,
};
